import { Injectable, Inject, forwardRef } from '@nestjs/common';
import { Repository, Raw, getConnection, getRepository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { LogsDTO } from './dto/logs.dto';
import { Logs } from './logs.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { LogsResponseModel } from 'libs/shared-models/user-logs/src/lib/Logs/logs-response.model';
// import { LogsDto } from './;
// import { ApplyForLeavesDTO } from './dto/apply-for-leaves.dto';

// import { LogsResponseModel} from '@gtpl/shared-models/gtpl';
@Injectable()
export class LogsService {
  // async getLogs(): Promise<LogsResponseModel> {
  //   try{
  //     const response= new LogsResponseModel();
  //     const logsDtos: LogsDto[] = [];
  //     // let logs_data= getRepository('Logs').createQueryBuilder("Logs").select(["concat(':',operation,table_name,logs.display_value) as message"])
  //     // .leftJoin("user","user","user.id=Logs.created_user")
  //     // .where('date(created_at) >= ( CURDATE() - INTERVAL 6 DAY ) ')
  //     // .execute();
  //     // logsDtos.push(logs_data);
  //     const logs_data=await getConnection() .createQueryBuilder() 
  //     .select(["concat(user.username,' : ',operation,'  ',table_name,'   ',Logs.display_value) as message,CONCAT(DATE_FORMAT(created_at,'%Y-%m-%d'),'::',DATE_FORMAT(created_at,'%H:%i:%s')) as timestamp"]) 
  //     .from(Logs, "Logs")
  //     .leftJoin("user","user","user.id=Logs.created_user")
  //     .where('date(created_at) >= ( CURDATE() - INTERVAL 7 DAY ) ') 
  //     // .where("user.id = :id", { id: 1 }) .getOne();
  //     .orderBy('Logs.log_id','DESC')
  //     .getRawMany();
  //     console.log('logs data');      
  //     console.log(logs_data);
      
  //     response.status = true;
  //     // response.data = [{message:"1st notification",timestamp:1596119686811},{message:"2nd notification",timestamp:1596119686812},{message:"3rd notification",timestamp:1596119686812}];
  //     response.data=logs_data;
  //     response.statusCode = 50000;
  //     response.internalMessage = 'Logs retrieved successfully';
  //     response.intlCode = 11108;
  //     return response;
  //   }catch(error){
  //     throw new Error('Logs not retrived.');
  //   }
    
  // }
  
  constructor(
             @InjectRepository(Logs)
             private logsRepository: Repository<Logs>
  ) {}


  async createLog(dto:LogsDTO): Promise<LogsResponseModel> {
    console.log("Service");
    console.log(dto);

    // await getConnection()
    // .createQueryBuilder()
    // .insert()
    // .into(Logs)
    // .values([
    //     { tableName:dto.tableName,operationName:dto.operationName,rowId:dto.rowId,status:dto.status,displayValue:dto.displayValue, createdUser: dto.createdUser, previousValue:dto.previousValue,presentValue:dto.presentValue}
    //  ])
    // .execute();
    // return true;
    const save = await this.logsRepository.save(dto)
    return new LogsResponseModel(true,1,'')
  }
}

